import React, { useCallback, useContext } from 'react'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { queryClient as qc, semesters } from 'keys'
import { NormalizerContext } from './NormalizerContext'
import { getReadingFluencyStatsFetch, getFluencyStatsFetch } from 'store/middlewares/rating.crud'
import { GraphStyles } from './Style'
import { Chip, IconButtonGroup, IconButtons } from 'components/Form'
import { thirdly } from 'styles/theme'
import { ReactComponent as TableIcon } from 'assets/icons/Table.svg';
import { ReactComponent as ChildrenIcon } from 'assets/icons/Children.svg';
import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { graphsHooks } from '../LinguisticLab/Graphs'
import { normalizerHooks, ScoreRatingTable } from '.'
import StatsBar from 'components/StatsBar'

const ScoreRatingItem = React.memo((props) => {
    const { activeScoreRatingIndex, changeActiveScoreItem, stats, updateStats, updateGraphRating, scoreRatingOptions, index, editScoreRatingOption, key, scoreRating } = props
    const { assessmentFilters, checkType } = useContext(NormalizerContext)
    const handleOnDragEnd = normalizerHooks.useHandleOnDragEnd(index);

    const fluencyStatsOptions = queryOptions({
        queryKey: [checkType.queryKey, scoreRating.grade, scoreRating.semester, scoreRating.category, scoreRating.method],
        queryFn: async () => {
            let filters = {
                ...assessmentFilters,
                category: assessmentFilters.category || scoreRating.category,
                grade_of_execution: scoreRating.grade,
                semester: scoreRating.semester,
            }
            if (scoreRating.method_name != "Normal_distribution")
                filters.method = scoreRating.method

            let { data } = await checkType.queryFn?.({ assessmentFilters: filters })
            updateStats(data.graph)
            return data
        },
        refetchIntervalInBackground: false,
        refetchInterval: false,
        refetchOnMount: false,
    })

    const fluencyStats = useQuery(fluencyStatsOptions)

    const isActiveItem = activeScoreRatingIndex == index

    return (
        <>
            <GraphStyles edit={isActiveItem}>
                <div className='sc-header-item'>
                    <div className='sc-detail'>
                        {!assessmentFilters.category &&
                            <Chip transparent color={thirdly}>{scoreRating.category_label}</Chip>}
                        <Chip transparent color={thirdly}>{scoreRating.method_name}</Chip>
                        <Chip transparent color={thirdly}>{scoreRating.grade_name}</Chip>
                        <Chip transparent color={thirdly}>{semesters[scoreRating.semester - 1].name}</Chip>
                        {!!fluencyStats.data?.assessment_count && <Chip transparent color={thirdly}>{`${fluencyStats.data?.assessment_count} מבדקים`}</Chip>}
                    </div>

                    <div className='sc-section-actions'>
                        <IconButtonGroup
                            selected={scoreRatingOptions?.showTable}
                            icon={TableIcon}
                            action={() => editScoreRatingOption(index, "showTable")}
                            iconSize={{
                                width: 20,
                                height: 20
                            }}
                        />
                        <IconButtonGroup
                            selected={scoreRatingOptions?.showChildren}
                            icon={ChildrenIcon}
                            action={() => editScoreRatingOption(index, "showChildren")}
                            iconSize={{
                                width: 20,
                                height: 20
                            }}
                        />
                        <IconButtonGroup
                            disabled={checkType.id=="correct_words_per_minute"}
                            selected={index == activeScoreRatingIndex}
                            icon={EditIcon}
                            action={() => changeActiveScoreItem(index)}
                            iconSize={{
                                width: 20,
                                height: 20
                            }}
                        />
                    </div>
                </div>
                {/* <div className='sc-table'>
                    {scoreRatingOptions?.showTable && <ScoreRatingDistribution distribution={distribution} />}
                </div> */}
                <div className='wrap-graph'>
                    <div className='graph'>
                        <StatsBar
                            checkType={checkType.id}
                            type="slider"
                            batItemWidth={checkType.barItemWidth}
                            draggable
                            // percent={checkType.percent}
                            handleOnDragEnd={handleOnDragEnd}
                            setShowStartBar={() => editScoreRatingOption(index, "showStartBar")}
                            setShowEndBar={() => editScoreRatingOption(index, "showEndBar")}
                            isDrag={isActiveItem}
                            showStartBar={scoreRatingOptions?.showStartBar}
                            showEndBar={scoreRatingOptions?.showEndBar}
                            graphKey={key}
                            disabled={false}
                            stats={stats}
                            sourceStats={fluencyStats.data?.graph}
                            updateStats={updateStats}
                            scoreRating={scoreRating}
                        />
                    </div>
                    {scoreRatingOptions?.showChildren &&
                        // <GraphStyles edit={isActiveItem}>
                        <StatsBar
                            checkType={checkType.id}
                            showArrows
                            viewItemCount
                            draggable
                            // percent={checkType.percent}
                            handleOnDragEnd={handleOnDragEnd}
                            setShowStartBar={() => editScoreRatingOption(index, "showStartBar")}
                            setShowEndBar={() => editScoreRatingOption(index, "showEndBar")}
                            isDrag={isActiveItem}
                            showChildren={true}
                            showStartBar={scoreRatingOptions?.showStartBar}
                            showEndBar={scoreRatingOptions?.showEndBar}
                            graphKey={key}
                            disabled={false}
                            stats={stats}
                            sourceStats={fluencyStats.data?.graph}
                            updateStats={updateStats}
                            scoreRating={scoreRating}
                        />
                        // </GraphStyles>
                    }
                </div>
            </GraphStyles>

        </>
    )
    // }
    // })
    // , (prevProps, nextProps) => {
    //     // השוואה רק על item, לא על otherProp

    //     return isEqual(prevProps.stats, nextProps.stats) &&
    //         isEqual(prevProps.key, nextProps.key) &&
    //         isEqual(prevProps.index, nextProps.index) &&

    //         //  isEqual(prevProps.index, nextProps.index) ||
    //         //     isEqual(prevProps.stats, nextProps.stats) ||
    //         isEqual(prevProps.scoreRatingOptions, nextProps.scoreRatingOptions)
    //     //  ||
    //     //     isEqual(prevProps.scoreRating, nextProps.scoreRating)

});

export default ScoreRatingItem